<template>
  <!-- <div
    class="spinnerContainer"
    :style="style ? 'background-color: #e3e3e3' : ''"
  >
    <div class="container text-center pt-5">
      <div class="text-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          width="70"
          height="70"
          class="loaderAnimation"
        >
          <path
            d="M358.512 270.956l-31.503-14.672-138.876-.447-33.72 15.207c-28.19 12.715-45.687 38.496-45.687 67.295V437c0 8.29 7.32 15 16.364 15h261.82c9.044 0 16.363-6.71 16.363-15v-99.188c0-28.39-17.147-54.01-44.76-66.856z"
            fill="#E6EEFF"
          />
          <path
            d="M358.512 270.956l-31.503-14.672-71.01-.23V452h130.91c9.044 0 16.363-6.71 16.363-15v-99.188c0-28.39-17.147-54.01-44.76-66.856z"
            fill="#DAE2F2"
          />
          <path
            d="M337.067 432.518C329.013 408.934 299.354 331 256 331s-73.013 77.934-81.067 101.518c-2.7 7.91 2.093 16.318 10.723 18.794h140.69c8.628-2.476 13.422-10.884 10.72-18.794z"
            fill="#9284DA"
          />
          <path
            d="M326.344 451.312c8.63-2.476 13.423-10.884 10.723-18.794C329.013 408.934 299.354 331 256 331v120.312h70.344z"
            fill="#796EB3"
          />
          <path
            d="M386.91 60H125.09c-9.044 0-16.363 6.71-16.363 15v76l33.918 30h226.918l33.71-30V75c0-8.29-7.32-15-16.364-15z"
            fill="#E6EEFF"
          />
          <path
            d="M386.91 60H256v121h113.563l33.71-30V75c0-8.29-7.32-15-16.364-15z"
            fill="#DAE2F2"
          />
          <path
            d="M386.91 90H125.09C98.02 90 76 69.814 76 45V15c0-8.29 7.32-15 16.364-15h327.273C428.68 0 436 6.71 436 15v30c0 24.814-22.02 45-49.09 45z"
            fill="#5C5F66"
          />
          <path
            d="M419.636 0H256v90h130.91C413.98 90 436 69.814 436 45V15c0-8.29-7.32-15-16.364-15z"
            fill="#53565C"
          />
          <path
            d="M419.636 512H92.364C83.32 512 76 505.29 76 497v-30c0-24.814 22.02-45 49.09-45h261.82c27.07 0 49.09 20.186 49.09 45v30c0 8.29-7.32 15-16.364 15z"
            fill="#5C5F66"
          />
          <path
            d="M386.91 422H256v90h163.636c9.045 0 16.364-6.71 16.364-15v-30c0-24.814-22.02-45-49.09-45z"
            fill="#53565C"
          />
          <path
            d="M108.727 151v22.412c0 25.297 16.645 54.385 46.12 67.47l32.778 14.587.51.367c33.707 24.412 21.798 15.788 56.295 40.768 6.392 5.86 16.747 5.86 23.14 0l59.44-40.322c.53-.358 31.38-14.92 31.965-15.196 28.43-13.427 44.297-41.19 44.297-66.636V151H108.727z"
            fill="#9284DA"
          />
          <path
            d="M256 301c4.187 0 8.374-1.465 11.57-4.395 35.564-24.124 23.017-15.613 59.44-40.322.53-.36 31.38-14.92 31.966-15.196 28.43-13.427 44.297-41.19 44.297-66.636V151H256v150z"
            fill="#796EB3"
          />
        </svg>

        <h4 class="mt-3">جار التحميل...</h4>
      </div>
    </div>
  </div> -->

  <!-- Loading Spinner Wrapper-->
  <div class="spinnerContainer text-center">
    <div class="loader-inner">
      <!-- Animated Spinner -->
      <div class="lds-roller mb-3">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'spinner',
  props: {
    addStyle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
.spinnerContainer {
  position: unset;
  top: 51px;
  height: 100vh;
  z-index: 999;
  text-align: center;
  padding-top: 15%;
}

.loader {
  width: 100vw;
  height: 100vh;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
}

.loader-inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Spinner */
.lds-roller {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 32px 32px;
}
.lds-roller div:after {
  content: ' ';
  display: block;
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #333;
  margin: -3px 0 0 -3px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 50px;
  left: 50px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 54px;
  left: 45px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 57px;
  left: 39px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 58px;
  left: 32px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 57px;
  left: 25px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 54px;
  left: 19px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 50px;
  left: 14px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 45px;
  left: 10px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
